<template>
<div>
    <div v-if="user.isAdmin">
        <resource-admin-table></resource-admin-table>
    </div>
    <div v-else>
        <resource-user-dashboard></resource-user-dashboard>
    </div>
</div>
</template>
<script>

    import {mapGetters} from 'vuex';
    import ResourceUserDashboard from './ResourceUserDashboard.vue'
    import ResourceAdminTable from './ResourceAdminTable.vue'

    export default {
        name: 'ResourceIndex',
        props: {},
        components:{ResourceAdminTable, ResourceUserDashboard},
        data: () => ({

        }),
        computed: {
            ...mapGetters({
                user: 'user',
                resources: 'resources',
            }),
        },
        watch: {},
        methods: {},
        mounted() {
            this.$store.dispatch('getAllResources')
        }
    }
</script>
